import { BASE_URL, SITE_NAME } from "@/components/Seo/Seo";

/** Organization — used on the home page. */
export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: `${BASE_URL}/`,
    logo: `${BASE_URL}/images/favicon.svg`,
    sameAs: ["https://t.me/fireflies_space"],
  };
}

/** WebSite — used on the home page. */
export function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: `${BASE_URL}/`,
    inLanguage: "ru",
  };
}

/**
 * BreadcrumbList from an ordered list of { name, path }.
 * Pass absolute paths starting with "/".
 */
export function breadcrumbSchema(items: { name: string; path: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${BASE_URL}${item.path}`,
    })),
  };
}

/** BlogPosting — used on an article page. */
export function blogPostingSchema(article: {
  title: string;
  slug: string;
  excerpt: string;
  preview_image: string;
  published_at: string;
  updated_at: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: article.title,
    description: article.excerpt,
    image: article.preview_image,
    datePublished: article.published_at,
    dateModified: article.updated_at,
    inLanguage: "ru",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${BASE_URL}/blog/${article.slug}`,
    },
    author: { "@type": "Organization", name: SITE_NAME },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: { "@type": "ImageObject", url: `${BASE_URL}/images/favicon.svg` },
    },
  };
}
